import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import "../styles/admin_user_nav.css";
import { Route, Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import labels from "../usermanagement/labels/users_en.json";

import ChangePassword from "../usermanagement/components/ChangePassword";
import { logout } from "../common/actions/commonActions";
import {
  setChangePasswordFlg,
  getAllRoles,
} from "../usermanagement/actions/userAction";
// import AdvertisementPostExamUpload from "../common/components/AdvertisementPostExamUpload";
import AdvertisementPostExamUpload from "../postExaminationProcessObjective/components/examData/AdvertisementPostExamUpload";
// import MastersCsvImport from "../common/components/MastersCsvImport";
import MastersCsvImport from "../postExaminationProcessObjective/components/examData/MastersCsvImport";
import CriteriaEditor from "../criteriaeditor/components/CriteriaEditor";
import ExamData from "../postExaminationProcessObjective/components/examData/examData";
import DataImportFrom from "../postExaminationProcessObjective/components/examData/dataImportFrom";
import PreExamReport from "../postExaminationProcessObjective/components/preExamReport/preExamReport";
import DataCount from "../postExaminationProcessObjective/components/preExamReport/DataCount";
import ExamReport from "../postExaminationProcessObjective/components/examReport/examReport";
import AnswerKeyReport from "../postExaminationProcessObjective/components/examReport/answerKeyReport";
import VersionMismatch from "../postExaminationProcessObjective/components/examReport/versionMismatch";
import AbsentList from "../postExaminationProcessObjective/components/examReport/absentList";
import ExaminersAndModeratorReport from "../postExaminationProcessObjective/components/examReport/examinersAndModeratorReport";
import AbsentListDescriptive from "../postExaminationProcessObjective/components/examReport/absentListDescriptive";
import Duplicate from "../postExaminationProcessObjective/components/examReport/duplicate";
import ResultGeneration from "../postExaminationProcessObjective/components/resultGeneration/resultGeneration";
import DescriptiveMarksCalculation from "../postExaminationProcessObjective/components/resultGeneration/descriptiveMarksCalculation";
import ObjectiveMarksCalculation from "../postExaminationProcessObjective/components/resultGeneration/objectiveMarksCalculation";
// import SeatMatrix from "../interviewProcess/components/seatMatrix";
import RecommededSeatMatrix from "../interviewProcess/components/seatMatrix/recommendedSeatMatrix";
import RecommendationCriteria from "../interviewProcess/components/seatMatrix/RecommendationCriteria";
import QualifyingSeatMatrix from "../interviewProcess/components/seatMatrix/qualifyingSeatMatrix";

import CutOff from "../interviewProcess/components/cutOff/cutOff";
import QualifyingCutOff from "../interviewProcess/components/cutOff/qualifyingCutOff";

import Report from "../interviewProcess/components/report/report";
import QualifyingReports from "../interviewProcess/components/report/qualifyingReports";
import DuplicateCodes from "../interviewProcess/components/report/duplicateCodes";

import InterviewSchedule from "../interviewProcess/components/interviewSchedule/interviewSchedule";
import GenerateInterviewAttendeeList from "../interviewProcess/components/interviewSchedule/generateInterviewAttendeeList";
import GenerateInterviewAbsenteeList from "../interviewProcess/components/interviewSchedule/generateInterviewAbsenteeList";
import GenerateInterviewSchedule from "../interviewProcess/components/interviewSchedule/generateInterviewSchedule";
import GenerateInterviewScheduleList from "../interviewProcess/components/interviewSchedule/generateInterviewScheduleList";

import InterviewReport from "../recommendationProcess/components/interviewReport";

import Merit from "../recommendationProcess/components/merit/merit";
import MeritGeneration from "../recommendationProcess/components/merit/meritGeneration";

import Recommendation from "../recommendationProcess/components/recommendation/recommendation";
import RecommendationStatistical from "../recommendationProcess/components/recommendation/recommendationStatistical";

import MasterEntry from "../accessRightsManagement/components/masterEntry/masterEntry";
import AuthorityMaster from "../accessRightsManagement/components/masterEntry/authorityMaster";
import DefineDepartment from "../accessRightsManagement/components/masterEntry/defineDepartment";
import DefineRole from "../accessRightsManagement/components/masterEntry/defineRole";
import UserRegistration from "../accessRightsManagement/components/masterEntry/userRegistration";

import ExamActivates from "../administration/components/examActivates/examActivates";
import CurrentActivates from "../administration/components/examActivates/currentActivates";
import PendingActivates from "../administration/components/examActivates/pendingActivates";

import AllReports from "../administration/components/allReports/allReports";
import InterviewPTReports from "../administration/components/allReports/interviewPTReports";
import PostExaminationWorkReport from "../administration/components/allReports/postExaminationWorkReport";
import ApplicationPreferenceReport from "../administration/components/allReports/ApplicationPreferenceReport";
import ApplicationPostPrefList from "../administration/components/allReports/applicationPostPrefList";
import RetotalingList from "../administration/components/allReports/retotalingList";
import PublishedReport from "../administration/components/allReports/publishedReport";
import RecommendationReports from "../administration/components/allReports/recommendationReports";

import MailSmsSend from "../administration/components/mailSMSSend";
import Dashboard from "../dashboard/components/dashboard";

import VerifyUser from "../login/components/VerifyUser";
import ResetPassword from "../login/components/ResetPassword";
import ForgotPassword from "../login/components/ForgotPassword";
import Login from "../login/components/Login";
import AssignAccessToRoleOrUser from "../common/components/AssignAccessToRoleOrUser";
import PresentAbsentReport from "../statistical-report/components/PresentAbsentReport";

import { getDepartment } from "../login/actions/loginAction";

import ChiefModeratorCriteria from "../postExaminationProcessObjective/components/examReport/chiefModeratorCriteria";
import ModeratorCriteria from "../postExaminationProcessObjective/components/examReport/ModeratorCriteria";
import InterviewListWithToken from "../interviewProcess/components/interviewSchedule/InterviewListWithToken";
import InterviewPostPreferencesList from "../interviewProcess/components/interviewSchedule/InterviewPostPreferencesList";
import AllotmentChartReport from "../interviewProcess/components/interviewSchedule/allotmentChartReport";

import {
  AuditOutlined,
  CopyOutlined,
  DesktopOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FileOutlined,
  FormOutlined,
  HomeOutlined,
  ImportOutlined,
  InsertRowAboveOutlined,
  PicCenterOutlined,
  PieChartOutlined,
  ReconciliationOutlined,
  SnippetsOutlined,
  SolutionOutlined,
  TeamOutlined,
  UserOutlined,
  NodeIndexOutlined
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, Tooltip, theme } from "antd";
import ApplicationFooter from "../common/components/ApplicationFooter";
import { useLocation } from "react-router-dom";
import OutOfRange from "../postExaminationProcessObjective/components/examReport/outOfRange";
import TransactionalDataImport from "../postExaminationProcessObjective/components/examData/TransactionalDataImport";
import InterviewMarks from "../interviewProcess/components/interviewSchedule/interviewMarks";
import Statistics from "../statistical-report/components/Statistics";
import BlacklistedCandidate from "../administration/components/allReports/blacklistedCandidate";
import QualifiedCandidate from "../administration/components/allReports/qualifiedCandidate";

import PhysicalTest from "../tests/components/PhysicalTest";
import MedicalTest from "../tests/components/MedicalTest";
import AllActivates from "../administration/components/examActivates/allActivaties";
import generalSlabReport from "../interviewProcess/components/slab/generalSlabReport";
import OrphenSlabReport from "../interviewProcess/components/slab/orphenSlabReport";
import EligibleRecommandationReport from "../administration/components/allReports/eligibleRecommandationReport";

import Interview from "../administration/components/allReports/interview";
import PreExam from "../administration/components/allReports/preExam";
import CutOffReport from "../administration/components/allReports/cutOff";
import StatisticalReports from "../administration/components/allReports/statisticalReports";
import GenerateQualifiedCandidate from "../interviewProcess/components/interviewSchedule/generateQualifiedCandidate";
import GenerateInterviewQualifiedCandidate from "../interviewProcess/components/interviewSchedule/generateQualifiedCandidate";
import GenerateRecommendationQualifiedCandidate from "../interviewProcess/components/interviewSchedule/generateRecommendationQualifiedCandidate";
import Recommandation from "../administration/components/allReports/recommandation";
import ResultFLow from "../common/components/ResultFlow";
const { Header, Content, Footer, Sider } = Layout;

const AdminUserNavcp = ({ collapsed, setCollapsed, ...props }) => {
  const location = useLocation();
  const selectedKey = location.pathname;
  const [openKeys, setOpenKeys] = useState([]);

  const [stepName, setName] = useState("1");
  const dispatch = useDispatch();
  const [roleName, setRoleName] = useState("");
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [items, setItemsData] = useState([]);
  const [moderatorCriteria, setModeratorCriteria] = useState(
    sessionStorage.getItem("moderatorCriteria") || "false"
  );
  const [chiefModeratorCriteria, setChiefModeratorCriteria] = useState(
    sessionStorage.getItem("chiefModeratorCriteria") || "false"
  ); 
  // const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();


  useEffect(() => {
    if (session && session.jwtResponse.token) {
      setRoleName(session.roleName);
    }

    setItemsData([
      // 1. Dashboard
      getItem(
        labels.Dashboard,
        "1",
        <HomeOutlined />,
        null,
        "/admin/dashboard",
        true
      ),

      // 2. Data Import (ONLY 2 ITEMS)
      getItem(labels.ExamData, "sub1", <ImportOutlined />, [
        getItem(
          labels.uploadMastersData,
          "36",
          <TeamOutlined />,
          null,
          "/admin/data-import/upload-masters-data",
          session.roleName == "superadmin" || session.roleName == "admin"
        ),
        getItem(
          labels.uploadAdvertimentPostExamData,
          "35",
          <TeamOutlined />,
          null,
          "/admin/data-import/upload-advertiment-post-exam-data",
          session.roleName == "superadmin" || session.roleName == "admin"
        ),
      ]),

      // 3. Result Flow (AFTER Data Import)
      getItem(
        labels.Result_flow,
        "47",
        <NodeIndexOutlined />,
        null,
        "/admin/result-flow",
        true
      ),

      // 4. Transactional Data Import (SEPARATE)
      getItem(
        labels.TransactionalDataImport,
        "42",
        <ImportOutlined />,
        null,
        "/admin/data-import/transactional-data-import",
        session.roleName == "superadmin" || session.roleName == "admin"
      ),

      // getItem(labels.PreExamReport, "sub2", <TeamOutlined />, [
      //   getItem(
      //     labels.DataCount,
      //     "3",
      //     null,
      //     null,
      //     "/admin/pre-exam-report/data-count",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      // ]),
      getItem(labels.ExamReport, "sub3", <SnippetsOutlined />, [
        getItem(
          labels.AnswerKeyReport,
          "4",
          null,
          null,
          "/admin/exam-report/answer-key-report",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.ExaminersAndModeratorReport,
          "6",
          null,
          null,
          "/admin/exam-report/examiners-and-moderator-report",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        // getItem(
        //   labels.ModeratorCriteria,
        //   "41",
        //   null,
        //   null,
        //   "/admin/exam-report/moderator-criteria",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        // getItem(
        //   labels.chiefModeratorCriteria,
        //   "43",
        //   null,
        //   null,
        //   "/admin/exam-report/chief-moderator-report",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        ...(moderatorCriteria === "true"
          ? [
            getItem(
              labels.ModeratorCriteria,
              "41",
              null,
              null,
              "/admin/exam-report/moderator-criteria",
              session.roleName == "superadmin" ||
              session.roleName == "secretary" ||
              session.roleName == "desk officer"
            ),
          ]
          : []),

        ...(chiefModeratorCriteria === "true"
          ? [
            getItem(
              labels.chiefModeratorCriteria,
              "43",
              null,
              null,
              "/admin/exam-report/chief-moderator-report",
              session.roleName == "superadmin" ||
              session.roleName == "secretary" ||
              session.roleName == "desk officer"
            ),
          ]
          : []),
        // getItem(
        //   labels.AbsentListDescriptive,
        //   "10",
        //   null,
        //   null,
        //   "/admin/exam-report/absent-list-descriptive",
        //   (session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') ? true : false
        // )
      ].filter(Boolean)
      ),
      getItem(labels.ObjectiveStatus, "sub14", <ExclamationCircleOutlined />, [
        getItem(
          labels.AbsentList,
          "5",
          null,
          null,
          "/admin/exam-report/absent-list",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.Duplicate,
          "39",
          null,
          null,
          "/admin/exam-report/duplicate-list",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.OutOfRange,
          "40",
          null,
          null,
          "/admin/exam-report/out-of-range",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.VersionMismatch,
          "38",
          null,
          null,
          "/admin/exam-report/version-mismatch",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
      ]),

      // getItem(labels.StatisticalReports, "sub15", <TeamOutlined />, [
      //   getItem(
      //     labels.PresentAbsentReport,
      //     "44",
      //     null,
      //     null,
      //     "/admin/statistical-report/present-absent-report",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      //   getItem(
      //     labels.Statistics,
      //     "45",
      //     null,
      //     null,
      //     "/admin/statistical-report/statistics",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      // ]),
      // getItem(labels.StatisticalReports, "sub15", <TeamOutlined />, [
      //   getItem(
      //     labels.Statistics,
      //     "44",
      //     null,
      //     null,
      //     "/admin/statistical-report/present-absent-report",
      //     (session.roleName=='superadmin' || session.roleName=='secretary' || session.roleName=='desk officer')?true:false
      //   ),
      // ]),
      getItem(labels.ResultGeneration, "sub4", <AuditOutlined />, [
        getItem(
          labels.ObjectiveMarksCalculation,
          "11",
          null,
          null,
          "/admin/result-generation/objective-marks-calculation",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        // getItem(
        //   labels.DescriptiveMarksCalculation,
        //   "12",
        //   null,
        //   null,
        //   "/admin/result-generation/descriptive-marks-calculation",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
      ]),
      getItem(labels.SeatMatrix, "sub5", <InsertRowAboveOutlined />, [
        getItem(
          labels.PreMains,
          "13",
          null,
          null,
          "/admin/seat-matrix/qualifying-seat-matrix",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ), 
      ]),
      // getItem(labels.CutOff, "sub6", <TeamOutlined />, [
      //   getItem(
      //     labels.CutOff,
      //     "15",
      //     null,
      //     null,
      //     "/admin/cut-off",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      //   // getItem(
      //   //   labels.QualifyingCutOff,
      //   //   "16",
      //   //   null,
      //   //   null,
      //   //   "/admin/cut-off/qualifying-cut-off",
      //   //   session.roleName == "superadmin" ||
      //   //     session.roleName == "secretary" ||
      //   //     session.roleName == "desk officer"
      //   //     ? true
      //   //     : false
      //   // ),
      // ]),
      getItem(labels.Slab, "sub21", <PicCenterOutlined />, [
        getItem(
          labels.GeneralSlab,
          "54",
          null,
          null,
          "/admin/slab/general-slab",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.OrphenSlab,
          "65",
          null,
          null,
          "/admin/slab/orphan-slab",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
      ]),
      // getItem(labels.Report, "sub7", <TeamOutlined />, [
      //   getItem(
      //     labels.QualifyingReports,
      //     "17",
      //     null,
      //     null,
      //     "/admin/report/qualifying-reports",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      //   getItem(
      //     labels.DuplicateCodes,
      //     "57",
      //     null,
      //     null,
      //     "/admin/report/duplicate-codes",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      // ]),
      getItem(labels.InterviewSchedule, "sub8", <SolutionOutlined />, [
        getItem(
          labels.GenerateInterviewSchedule,
          "18",
          null,
          null,
          "/admin/interview-schedule/generate-interview-schedule",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        // getItem(
        //   labels.GenerateInterviewScheduleList,
        //   "19",
        //   null,
        //   null,
        //   "/admin/interview-schedule/generate-interview-schedule-list",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        // getItem(
        //   labels.GenerateInterviewAttendeeList,
        //   "20",
        //   null,
        //   null,
        //   "/admin/interview-schedule/generate-interview-attendee-list",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        // getItem(
        //   labels.GenerateInterviewAbsenteeList,
        //   "37",
        //   null,
        //   null,
        //   "/admin/interview-schedule/generate-interview-absentee-list",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        // getItem(
        //   labels.InterviewMarks,
        //   "45",
        //   null,
        //   null,
        //   "/admin/interview-schedule/interview-marks",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        getItem(
          labels.InterviewMarks,
          "21",
          null,
          null,
          "/admin/interview-report",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.interviewRecommendation,
          "14",
          null,
          null,
          "/admin/seat-matrix/recommended-seat-matrix",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.GenerateInterviewQualifiedCandidate,
          "59",
          null,
          null,
          "/admin/interview-schedule/generate-interview-qualified-Candidate",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.RecommendationCriteria,
          "58",
          null,
          null,
          "/admin/seat-matrix/recommendation-criteria",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.GenerateRecommendationQualifiedCandidate,
          "60",
          null,
          null,
          "/admin/interview-schedule/generate-recommendation-qualified-Candidate",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.MeritGeneration,
          "22",
          null,
          null,
          "/admin/merit/merit-generation",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        // getItem(
        //   labels.InterviewList,
        //   "54",
        //   null,
        //   null,
        //   "/admin/interview-schedule/interview-list-with-token",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        // getItem(
        //   labels.InterviewPostPreferencesList,
        //   "55",
        //   null,
        //   null,
        //   "/admin/interview-schedule/interview-post-preference-list",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? false
        //     : false
        // ),
        // getItem(
        //   labels.AllotmentChartReport,
        //   "56",
        //   null,
        //   null,
        //   "/admin/interview-schedule/allotment-chart-report",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? false
        //     : false
        // ),
      ]),
      // getItem(
      //   labels.InterviewReport,
      //   "21",
      //   <TeamOutlined />,
      //   null,
      //   "/admin/interview-report",
      //   session.roleName == "superadmin" ||
      //     session.roleName == "secretary" ||
      //     session.roleName == "desk officer"
      //     ? true
      //     : false
      // ),
      getItem(labels.Tests, "sub20", <EditOutlined />, [
        getItem(
          labels.PhysicalTest,
          "51",
          null,
          null,
          "/admin/phycial-and-medical-test/physical-test",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.MedicalTest,
          "52",
          null,
          null,
          "/admin/phycial-and-medical-test/medical-test",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
      ]),

      // getItem(
      //   labels.uploadAdvertimentPostExamData,
      //   "35",
      //   <TeamOutlined />,
      //   null,
      //   "/admin/upload-advertiment-post-exam-data",
      //   (session.roleName=='superadmin' || session.roleName=='admin')?true:false
      // ),
      // getItem(
      //   labels.uploadMastersData,
      //   "36",
      //   <TeamOutlined />,
      //   null,
      //   "/admin/upload-masters-data",
      //   (session.roleName=='superadmin' || session.roleName=='admin')?true:false
      // ),

      // getItem(labels.Merit, "sub9", <TeamOutlined />, [
      //   getItem(
      //     labels.MeritGeneration,
      //     "22",
      //     null,
      //     null,
      //     "/admin/merit/merit-generation",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      // ]),
      // getItem(labels.Recommendation, "sub10", <TeamOutlined />, [
      //   getItem(
      //     labels.RecommendationStatistical,
      //     "23",
      //     null,
      //     null,
      //     "/admin/recommendation/recommendation-statistical",
      //     session.roleName == "superadmin" ||
      //       session.roleName == "secretary" ||
      //       session.roleName == "desk officer"
      //       ? true
      //       : false
      //   ),
      // ]),
      getItem(labels.UserRole, "sub11", <TeamOutlined />, [
        getItem(
          labels.DefineDepartment,
          "24",
          null,
          null,
          "/admin/master-entry/define-department",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.DefineRole,
          "46",
          null,
          null,
          "/admin/master-entry/define-role",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        // getItem(
        //   labels.AuthorityMaster,
        //   "25",
        //   null,
        //   null,
        //   "/admin/master-entry/authority-master",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        getItem(
          labels.UserRegistration,
          "26",
          null,
          null,
          "/admin/master-entry/user-registration",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.AssignAccessToRoleOrUser,
          "99",
          null,
          null,
          "/admin/assign-access-to-role-or-user",
          session.roleName == "superadmin" ? true : false
        ),
      ]),
      getItem(labels.ExamActivates, "sub12", <FormOutlined />, [
        // getItem(
        //   labels.CurrentActivates,
        //   "27",
        //   null,
        //   null,
        //   "/admin/exam-activates/current-activates",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        // getItem(
        //   labels.PendingActivates,
        //   "28",
        //   null,
        //   null,
        //   "/admin/exam-activates/pending-activates",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        getItem(
          labels.AllActivaties,
          "53",
          null,
          null,
          "/admin/exam-activates/all-activates",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
      ]),
      getItem(labels.AllReports, "sub13", <ReconciliationOutlined />, [
        // getItem(
        //   labels.PublishedReport,
        //   "29",
        //   null,
        //   null,
        //   "/admin/all-reports/published-report",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        // getItem(
        //   labels.PostExaminationWorkReport,
        //   "30",
        //   null,
        //   null,
        //   "/admin/all-reports/post-examination-work-report",
        //   (session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') ? true : false
        // ),
        getItem(
          labels.Interview,
          "61",
          null,
          null,
          "/admin/all-reports/interview",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.PreExam,
          "62",
          null,
          null,
          "/admin/all-reports/pre-exam",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.CutOffReport,
          "63",
          null,
          null,
          "/admin/all-reports/cut-off",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.Result,
          "50",
          null,
          null,
          "/admin/all-reports/post-examination-work-report/rollNo-qualified-candidate",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.QualifyingReports,
          "17",
          null,
          null,
          "/admin/report/qualifying-reports",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.Vigatvari,
          "66",
          null,
          null,
          "/admin/all-reports/recommendation",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.StatisticalReports,
          "64",
          null,
          null,
          "/admin/all-reports/satistical-report",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.ApplicationPreferenceReport,
          "31",
          null,
          null,
          "/admin/all-reports/post-examination-work-report/application-preference-report",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.ApplicationPostPreferenceReport,
          "47",
          null,
          null,
          "/admin/all-reports/post-examination-work-report/application-post-preference-report",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.RetotalingList,
          "48",
          null,
          null,
          "/admin/all-reports/post-examination-work-report/retotaling-list",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? false
            : false
        ),
        getItem(
          labels.RecommendationReports,
          "32",
          null,
          null,
          "/admin/all-reports/post-examination-work-report/recommendation-reports",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.RecommendationStatistical,
          "23",
          null,
          null,
          "/admin/recommendation/recommendation-statistical",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.EligibleRecommendationReports,
          "60",
          null,
          null,
          "/admin/all-reports/post-examination-work-report/eligible-recommendation-reports",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        // getItem(
        //   labels.InterviewPTReports,
        //   "33",
        //   null,
        //   null,
        //   "/admin/all-reports/post-examination-work-report/interview-pt-reports",
        //   session.roleName == "superadmin" ||
        //     session.roleName == "secretary" ||
        //     session.roleName == "desk officer"
        //     ? true
        //     : false
        // ),
        getItem(
          labels.blackListedCandidate,
          "49",
          null,
          null,
          "/admin/all-reports/post-examination-work-report/blacklisted-candidate",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
        getItem(
          labels.DuplicateCodes,
          "57",
          null,
          null,
          "/admin/report/duplicate-codes",
          session.roleName == "superadmin" ||
            session.roleName == "secretary" ||
            session.roleName == "desk officer"
            ? true
            : false
        ),
      ]),
      // getItem(
      //   labels.MailSMSSend,
      //   "34",
      //   <TeamOutlined />,
      //   null,
      //   "/admin/mail-sms-send",
      //   session.roleName == "superadmin" ||
      //     session.roleName == "secretary" ||
      //     session.roleName == "desk officer"
      //     ? true
      //     : false
      // ),
    ]);
    switch (props.location.pathname) {
      case "/admin/dashboard":
        return setName("1");
      case "/admin/result-flow":
        return setName("47");
      case "/admin/assign-access-to-role-or-user":
        return setName("99");
      case "/admin/data-import/data-import-from":
        setOpenKeys(["sub1"]);
        return setName("2");
      case "/admin/pre-exam-report/data-count":
        setOpenKeys(["sub2"]);
        return setName("3");
      case "/admin/exam-report/answer-key-report":
        setOpenKeys(["sub3"]);
        return setName("4");
      case "/admin/exam-report/absent-list":
        setOpenKeys(["sub14"]);
        return setName("5");
      case "/admin/exam-report/examiners-and-moderator-report":
        setOpenKeys(["sub3"]);
        return setName("6");
      case "/admin/exam-report/absent-list-descriptive":
        setOpenKeys(["sub3"]);
        return setName("10");
      case "/admin/result-generation/objective-marks-calculation":
        setOpenKeys(["sub4"]);
        return setName("11");
      case "/admin/result-generation/descriptive-marks-calculation":
        setOpenKeys(["sub4"]);
        return setName("12");
      case "/admin/seat-matrix/qualifying-seat-matrix":
        setOpenKeys(["sub5"]);
        return setName("13");
      case "/admin/seat-matrix/recommended-seat-matrix":
        setOpenKeys(["sub5"]);
        return setName("14");
      case "/admin/seat-matrix/recommendation-criteria":
        setOpenKeys(["sub5"]);
        return setName("58");
      case "/admin/cut-off":
        setOpenKeys(["sub6"]);
        return setName("15");
      case "/admin/cut-off/qualifying-cut-off":
        setOpenKeys(["sub6"]);
        return setName("16");
      case "/admin/report/qualifying-reports":
        setOpenKeys(["sub7"]);
        return setName("17");
      case "/admin/report/duplicate-codes":
        setOpenKeys(["sub7"]);
        return setName("57");
      case "/admin/interview-schedule/generate-interview-schedule":
        setOpenKeys(["sub8"]);
        return setName("18");
      case "/admin/interview-schedule/generate-interview-qualified-Candidate":
        setOpenKeys(["sub8"]);
        return setName("59");
      case "/admin/interview-schedule/generate-recommendation-qualified-Candidate":
        setOpenKeys(["sub8"]);
        return setName("60");

      case "/admin/interview-schedule/generate-interview-schedule-list":
        setOpenKeys(["sub8"]);
        return setName("19");
      case "/admin/interview-schedule/generate-interview-attendee-list":
        setOpenKeys(["sub8"]);
        return setName("20");
      case "/admin/interview-schedule/interview-marks":
        setOpenKeys(["sub8"]);
        return setName("45");
      case "/admin/interview-schedule/interview-list-with-token":
        setOpenKeys(["sub8"]);
        return setName("54");
      case "/admin/interview-report":
        return setName("21");
      case "/admin/merit/merit-generation":
        setOpenKeys(["sub9"]);
        return setName("22");
      case "/admin/recommendation/recommendation-statistical":
        setOpenKeys(["sub10"]);
        return setName("23");
      case "/admin/master-entry/define-department":
        setOpenKeys(["sub11"]);
        return setName("24");
      case "/admin/master-entry/authority-master":
        setOpenKeys(["sub11"]);
        return setName("25");
      case "/admin/master-entry/user-registration":
        setOpenKeys(["sub11"]);
        return setName("26");
      // case "/admin/exam-activates/current-activates":
      //   setOpenKeys(["sub12"]);
      //   return setName("27");
      // case "/admin/exam-activates/pending-activates":
      //   setOpenKeys(["sub12"]);
      //   return setName("28");
      case "/admin/exam-activates/all-activates":
        setOpenKeys(["sub12"]);
        return setName("53");
      case "/admin/all-reports/published-report":
        setOpenKeys(["sub13"]);
        return setName("29");
      // case "/admin/all-reports/post-examination-work-report":
      //   setOpenKeys(['sub13'])
      //   return setName("30");
      case "/admin/all-reports/post-examination-work-report/application-preference-report":
        setOpenKeys(["sub13"]);
        return setName("31");
      case "/admin/all-reports/post-examination-work-report/recommendation-reports":
        setOpenKeys(["sub13"]);
        return setName("32");
      case "/admin/all-reports/post-examination-work-report/interview-pt-reports":
        setOpenKeys(["sub13"]);
        return setName("33");
      case "/admin/all-reports/post-examination-work-report/eligible-recommendation-reports":
        setOpenKeys(["sub13"]);
        return setName("60");
      case "/admin/all-reports/post-examination-work-report/blacklisted-Candidate":
        setOpenKeys(["sub13"]);
        return setName("49");
      case "/admin/all-reports/post-examination-work-report/rollNo-qualified-candidate":
        setOpenKeys(["sub13"]);
        return setName("50");
      // /admin/all-reports/post-examination-work-report/rollNo-qualified-candidate
      case "/admin/mail-sms-send":
        return setName("34");
      case "/admin/data-import/upload-advertiment-post-exam-data":
        setOpenKeys(["sub1"]);
        return setName("35");
      case "/admin/data-import/upload-masters-data":
        setOpenKeys(["sub1"]);
        return setName("36");
      case "/admin/interview-schedule/generate-interview-absentee-list":
        setOpenKeys(["sub8"]);
        return setName("37");
      case "/admin/exam-report/version-mismatch":
        setOpenKeys(["sub14"]);
        return setName("38");
      case "/admin/exam-report/duplicate-list":
        setOpenKeys(["sub14"]);
        return setName("39");
      case "/admin/exam-report/out-of-range":
        setOpenKeys(["sub14"]);
        return setName("40");
      case "/admin/exam-report/moderator-criteria":
        setOpenKeys(["sub3"]);
        return setName("41");
      case "/admin/exam-report/chief-moderator-report":
        setOpenKeys(["sub3"]);
        return setName("43");
      case "/admin/statistical-report/present-absent-report":
        setOpenKeys(["sub15"]);
        return setName("44");
      case "/admin/statistical-report/statistics":
        setOpenKeys(["sub15"]);
        return setName("45");
      case "/admin/data-import/transactional-data-import":
        // setOpenKeys(["sub1"]);
        return setName("42");
      case "/admin/master-entry/define-role":
        setOpenKeys(["sub11"]);
        return setName("46");
      case "/admin/all-reports/post-examination-work-report/application-post-preference-report":
        setOpenKeys(["sub13"]);
        return setName("47");
      case "/admin/all-reports/retotaling-list":
        setOpenKeys(["sub13"]);
        return setName("48");
      case "/admin/phycial-and-medical-test/physical-test":
        setOpenKeys(["sub20"]);
        return setName("51");
      case "/admin/phycial-and-medical-test/medical-test":
        setOpenKeys(["sub20"]);
        return setName("52");
      case "/admin/slab/general-slab":
        setOpenKeys(["sub21"]);
        return setName("54");
      case "/admin/slab/orphan-slab":
        setOpenKeys(["sub21"]);
        return setName("65");
      case "/admin/interview-schedule/interview-post-preference-list":
        setOpenKeys(["sub8"]);
        return setName("55");
      case "/admin/interview-schedule/allotment-chart-report":
        setOpenKeys(["sub8"]);
        return setName("56");
      case "/admin/all-reports/interview":
        setOpenKeys(["sub13"]);
        return setName("61");
      case "/admin/all-reports/pre-exam":
        setOpenKeys(["sub13"]);
        return setName("62");
      case "/admin/all-reports/cut-off":
        setOpenKeys(["sub13"]);
        return setName("63");
      case "/admin/all-reports/satistical-report":
        setOpenKeys(["sub13"]);
        return setName("64");
      case "/admin/all-reports/recommendation":
        setOpenKeys(["sub13"]);
        return setName("66")
      default:
        return setName("1");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getItem = (label, key, icon, children, url, access = true) => {
    return {
      key,
      icon,
      children,
      label,
      url,
      access,
    };
  };
  useEffect(() => {
    dispatch(getDepartment());
    dispatch(getAllRoles());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { allDepartments } = useSelector((state) => state.common, shallowEqual);

  const { roleByDept } = useSelector(
    (state) => state.userManagementReducer,
    shallowEqual
  );
  const routes = [
    { path: "/", component: Login },
    { path: "/admin/login", component: Login },
    { path: "/admin/forgotPassword", component: ForgotPassword },
    { path: "/admin/verifyuser", component: VerifyUser },
    { path: "/admin/resetpassword", component: ResetPassword },
    { path: "/admin/criteriaeditor", component: CriteriaEditor },
    { path: "/admin/dashboard", component: Dashboard },
    { path: "/admin/result-flow", component: ResultFLow },
    { path: "/admin/exam-data", component: ExamData },
    { path: "/admin/data-import/data-import-from", component: DataImportFrom },
    {
      path: "/admin/data-import/transactional-data-import",
      component: TransactionalDataImport,
    },
    { path: "/admin/pre-exam-report", component: PreExamReport },
    { path: "/admin/pre-exam-report/data-count", component: DataCount },
    { path: "/admin/exam-report", component: ExamReport },
    {
      path: "/admin/exam-report/answer-key-report",
      component: AnswerKeyReport,
    },
    { path: "/admin/exam-report/absent-list", component: AbsentList },
    {
      path: "/admin/exam-report/examiners-and-moderator-report",
      component: ExaminersAndModeratorReport,
    },
    {
      path: "/admin/exam-report/chief-moderator-report",
      component: ChiefModeratorCriteria,
    },
    {
      path: "/admin/exam-report/moderator-criteria",
      component: ModeratorCriteria,
    },
    {
      path: "/admin/exam-report/absent-list-descriptive",
      component: AbsentListDescriptive,
    },
    {
      path: "/admin/exam-report/duplicate-list",
      component: Duplicate,
    },
    {
      path: "/admin/exam-report/out-of-range",
      component: OutOfRange,
    },
    { path: "/admin/result-generation", component: ResultGeneration },
    {
      path: "/admin/result-generation/objective-marks-calculation",
      component: ObjectiveMarksCalculation,
    },
    {
      path: "/admin/result-generation/descriptive-marks-calculation",
      component: DescriptiveMarksCalculation,
    },
    {
      path: "/admin/seat-matrix/qualifying-seat-matrix",
      component: QualifyingSeatMatrix,
    },
    {
      path: "/admin/seat-matrix/recommended-seat-matrix",
      component: RecommededSeatMatrix,
    },
    {
      path: "/admin/seat-matrix/recommendation-criteria",
      component: RecommendationCriteria,
    },
    { path: "/admin/cut-off", component: CutOff },
    { path: "/admin/cut-off/qualifying-cut-off", component: QualifyingCutOff },
    { path: "/admin/slab/general-slab", component: generalSlabReport },
    { path: "/admin/slab/orphan-slab", component: OrphenSlabReport },
    { path: "/admin/report", component: Report },
    { path: "/admin/report/qualifying-reports", component: QualifyingReports },
    { path: "/admin/report/duplicate-codes", component: DuplicateCodes },
    { path: "/admin/interview-schedule", component: InterviewSchedule },
    {
      path: "/admin/interview-schedule/generate-interview-schedule",
      component: GenerateInterviewSchedule,
    },
    {
      path: "/admin/interview-schedule/generate-interview-qualified-Candidate",
      component: GenerateInterviewQualifiedCandidate,
    },
    {
      path: "/admin/interview-schedule/generate-recommendation-qualified-Candidate",
      component: GenerateRecommendationQualifiedCandidate,
    },
    {
      path: "/admin/interview-schedule/interview-marks",
      component: InterviewMarks,
    },
    {
      path: "/admin/interview-schedule/generate-interview-schedule-list",
      component: GenerateInterviewScheduleList,
    },
    {
      path: "/admin/interview-schedule/generate-interview-attendee-list",
      component: GenerateInterviewAttendeeList,
    },
    {
      path: "/admin/interview-schedule/generate-interview-absentee-list",
      component: GenerateInterviewAbsenteeList,
    },
    {
      path: "/admin/interview-schedule/interview-list-with-token",
      component: InterviewListWithToken,
    },
    {
      path: "/admin/interview-schedule/interview-post-preference-list",
      component: InterviewPostPreferencesList,
    },
    {
      path: "/admin/interview-schedule/allotment-chart-report",
      component: AllotmentChartReport,
    },
    { path: "/admin/interview-report", component: InterviewReport },
    { path: "/admin/merit", component: Merit },
    { path: "/admin/merit/merit-generation", component: MeritGeneration },
    { path: "/admin/recommendation", component: Recommendation },
    {
      path: "/admin/recommendation/recommendation-statistical",
      component: RecommendationStatistical,
    },
    { path: "/admin/master-entry", component: MasterEntry },
    {
      path: "/admin/master-entry/define-department",
      component: DefineDepartment,
    },
    {
      path: "/admin/master-entry/define-role",
      component: DefineRole,
    },
    {
      path: "/admin/master-entry/authority-master",
      component: AuthorityMaster,
    },
    {
      path: "/admin/master-entry/user-registration",
      component: UserRegistration,
    },
    { path: "/admin/exam-activates", component: ExamActivates },
    // {
    //   path: "/admin/exam-activates/current-activates",
    //   component: CurrentActivates,
    // },
    // {
    //   path: "/admin/exam-activates/pending-activates",
    //   component: PendingActivates,
    // },
    {
      path: "/admin/exam-activates/all-activates",
      component: AllActivates,
    },
    { path: "/admin/all-reports", component: AllReports },
    { path: "/admin/all-reports/interview", component: Interview },
    { path: "/admin/all-reports/pre-exam", component: PreExam },
    { path: "/admin/all-reports/cut-off", component: CutOffReport },
    {
      path: "/admin/all-reports/satistical-report",
      component: StatisticalReports,
    },
    { path: "/admin/all-reports/recommendation", component: Recommandation },
    { path: "/admin/all-reports/published-report", component: PublishedReport },
    // {
    //   path: "/admin/all-reports/post-examination-work-report",
    //   component: PostExaminationWorkReport,
    // },
    {
      path: "/admin/all-reports/post-examination-work-report/application-preference-report",
      component: ApplicationPreferenceReport,
    },
    {
      path: "/admin/all-reports/post-examination-work-report/application-post-preference-report",
      component: ApplicationPostPrefList,
    },
    {
      path: "/admin/all-reports/post-examination-work-report/retotaling-list",
      component: RetotalingList,
    },
    {
      path: "/admin/all-reports/post-examination-work-report/recommendation-reports",
      component: RecommendationReports,
    },
    {
      path: "/admin/all-reports/post-examination-work-report/eligible-recommendation-reports",
      component: EligibleRecommandationReport,
    },
    {
      path: "/admin/all-reports/post-examination-work-report/interview-pt-reports",
      component: InterviewPTReports,
    },
    {
      path: "/admin/all-reports/post-examination-work-report/blacklisted-candidate",
      component: BlacklistedCandidate,
    },
    {
      path: "/admin/all-reports/post-examination-work-report/rollNo-qualified-candidate",
      component: QualifiedCandidate,
    },
    { path: "/admin/mail-sms-send", component: MailSmsSend },
    {
      path: "/admin/data-import/upload-advertiment-post-exam-data",
      component: AdvertisementPostExamUpload,
    },
    {
      path: "/admin/data-import/upload-masters-data",
      component: MastersCsvImport,
    },
    {
      path: "/admin/assign-access-to-role-or-user",
      component: AssignAccessToRoleOrUser,
    },
    {
      path: "/admin/statistical-report/present-absent-report",
      component: PresentAbsentReport,
    },
    {
      path: "/admin/statistical-report/statistics",
      component: Statistics,
    },
    {
      path: "/admin/exam-report/version-mismatch",
      component: VersionMismatch,
    },
    {
      path: "/admin/phycial-and-medical-test/physical-test",
      component: PhysicalTest,
    },
    {
      path: "/admin/phycial-and-medical-test/medical-test",
      component: MedicalTest,
    },
  ];

  const handleSubMenuClick = (key) => {
    if (!openKeys.includes(key)) {
      openKeys.length = 0;
      setOpenKeys([key]);
    }
  };

  return (
    <div>
      <Layout
        style={{
          minHeight: "100vh",
        }}
      >
        <Sider
          width={250}
          style={{
            overflow: "auto",
            // height: "100vh",
            marginBottom: "48px",
            position: "fixed",
            left: 0,
            top: 171,
            bottom: 0,
          }}
          trigger={null}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div className="demo-logo-vertical" />
          {/* <Menu style={{ backgroundColor: "#354b89" }} theme="dark" defaultSelectedKeys={['1']} selectedKeys={[selectedKey]} mode="inline" */}
          <Menu
            className="custom-admin-sidebar"
            style={{ backgroundColor: "#ffffff", color: "#4b5563" }}
            theme="light"
            defaultSelectedKeys={["1"]}
            selectedKeys={[selectedKey]}
            mode="inline"
            // items={items} />
            openKeys={openKeys}
            onOpenChange={(keys) => {
              setOpenKeys(keys);
            }}
          >
            {items.map((item) =>
              item.access ? (
                item.children ? (
                  <Menu.SubMenu
                    key={item.key}
                    icon={item.icon}
                    title={item.label}
                    onTitleClick={() => handleSubMenuClick(item.key)}
                  >
                    {item.children.map((subItem) => (
                      <Menu.Item key={subItem.url}>
                        {subItem.url ? (
                          // Use a Link if a URL is specified
                          <Tooltip title={subItem.label} placement="right">
                            {" "}
                            <Link
                              className="text-decoration-none"
                              to={subItem.url}
                            >
                              {subItem.label}
                            </Link>
                          </Tooltip>
                        ) : (
                          // Use a regular anchor tag if no URL is specified
                          <Tooltip title={subItem.label}>
                            <a className="text-decoration-none" href="#">
                              {subItem.label}
                            </a>
                          </Tooltip>
                        )}
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                ) : (
                  <Menu.Item key={item.url} icon={item.icon}>
                    {item.url ? (
                      // Use a Link if a URL is specified
                      !collapsed ? (
                        <Tooltip title={item.label} placement="right">
                          {" "}
                          <Link className="text-decoration-none" to={item.url}>
                            {item.label}
                          </Link>
                        </Tooltip>
                      ) : (
                        <Link className="text-decoration-none" to={item.url}>
                          {item.label}
                        </Link>
                      )
                    ) : (
                      // Use a regular anchor tag if no URL is specified
                      <Tooltip title={item.label}>
                        {" "}
                        <a className="text-decoration-none" href="#">
                          {item.label}
                        </a>
                      </Tooltip>
                    )}
                  </Menu.Item>
                )
              ) : (
                ""
              )
            )}
          </Menu>
        </Sider>
        <Layout
          className="site-layout"
          style={{
            transition: "margin-left 0.3s ease 0s",
            marginLeft: collapsed ? 0 : 200,
          }}
        >
          <Content
            style={{
              margin: "0 16px",
            }}
          >
            {/* <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        /> */}

            {/* <ul className="nav nav-tabs main-nav-tab bottom-shadow row top-nav ">
              <li className="nav-item " key={0}>
                <div className="d-block pos-fixed rt-0 tp-0 zindex-1">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      id="dropdown-basic"
                      className="mt-10 mr-15 textTransf-cap"
                    >
                      {props.fullName}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item key={0} className="font-14 text-center">
                        {" "}
                        <img
                          className="h-20 w-20"
                          src="../../logos/default_user_profile.png"
                          alt="user Profile"
                        />
                      </Dropdown.Item>
                      {allDepartments
                        .filter(
                          (singleDepartment) =>
                            singleDepartment.id == props.deaprtmentId
                        )
                        .map((filteredDepartment) => (
                          <Dropdown.Item key={0} className="font-14">
                            {labels.Department} : {filteredDepartment.name}
                          </Dropdown.Item>
                        ))}

                      {roleByDept
                        .filter((singleRole) => singleRole.id == props.roleId)
                        .map((filteredRole) => (
                          <Dropdown.Item key={1} className="font-14">
                            {labels.Role} : {filteredRole.name}
                          </Dropdown.Item>
                        ))}
                      <Dropdown.Item
                        key={2}
                        className="font-14"
                        onClick={() => dispatch(setChangePasswordFlg(true))}
                      >
                        {labels.ChangePassword}
                      </Dropdown.Item>
                      <Dropdown.Item
                        key={3}
                        className="font-14"
                        onClick={() => dispatch(logout(props))}
                      >
                        {labels.Logout}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </li>
            </ul>  */}
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact
                component={route.component}
              />
            ))}
            <ChangePassword {...props} />
            {/* <ApplicationFooter /> */}
          </Content>
          {/* <Footer style={{ textAlign: 'center' }}>Ant Design ©2023 Created by Ant UED</Footer> */}
        </Layout>
      </Layout>
    </div>
  );
};

export default AdminUserNavcp;
